import { sva } from '@news/styled-system/css'

export const carouselRecipe = sva({
    slots: ['root', 'viewport', 'track', 'slide', 'button'],
    base: {
        root: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
        },
        viewport: {
            overflow: 'hidden',
            width: 'full',
        },
        track: {
            display: 'flex',
            willChange: 'transform',
        },
        slide: {
            flexShrink: 0,
        },
        button: {
            position: 'absolute',
            top: '[50%]',
            transform: 'translateY(-50%)',
            opacity: '[0.9]',
            background: '[#f6f6f6]',
            borderRadius: 'full',
            height: '[50px]',
            width: '[50px]',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            border: 'none',
            zIndex: 1,
            _hover: {
                opacity: '[1]',
            },
            '& i': {
                fontSize: '[24px]',
                color: '[#000]',
            },
        },
    },
    variants: {
        direction: {
            left: {
                button: {
                    left: '[-25px]',
                },
            },
            right: {
                button: {
                    right: '[-25px]',
                },
            },
        },
    },
})
